import React from "react";
import { signOut } from 'firebase/auth';
import { auth } from '../Logica/firebase/firebase';

const CustomModal = ({
  show,
  onClose,
  title,
  message,
  tipo = "info",
  showLogout = false,
  mostrarDesinscribir = false,
  onDesinscribir,
}) => {
  if (!show) return null;

  const handleLogout = async () => {
    try {
      await signOut(auth);
      onClose();
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    }
  };

  const tipoClase = {
    exito: "bg-success",
    error: "bg-danger",
    advertencia: "bg-warning",
    info: "bg-success",
  };

  // Si el mensaje termina en "... (123456)", se separa el código para
  // mostrarlo en su propio recuadro, en vez de como texto plano entre paréntesis.
  const coincidenciaCodigo =
    typeof message === "string" ? message.match(/^(.*?)\s*\(([^)]+)\)\s*$/) : null;
  const mensajePrincipal = coincidenciaCodigo ? coincidenciaCodigo[1].trim() : message;
  const codigo = coincidenciaCodigo ? coincidenciaCodigo[2] : null;

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content text-center">
          <div className={`modal-header ${tipoClase[tipo] || "bg-secondary"} text-white`}>
            <h5 className="modal-title">
              {title || (tipo === "exito" ? "✅ ¡Éxito!" : tipo === "error" ? "❌ Error" : "")}
            </h5>
          </div>
          <div className="modal-body">
            <p style={{ whiteSpace: "pre-wrap" }}>{mensajePrincipal}</p>
            {codigo && (
              <div>
                <p className="mb-2 text-muted">Código de registro</p>
                <div
                  className="d-inline-block bg-light border border-success rounded-3 px-4 py-2 fs-3 fw-bold text-success"
                  style={{ letterSpacing: "2px" }}
                >
                  {codigo}
                </div>
              </div>
            )}
          </div>
          <div className="modal-footer justify-content-center">
            {mostrarDesinscribir && (
              <button className="btn btn-outline-danger" onClick={onDesinscribir}>
                Cambiar actividad
              </button>
            )}
            {showLogout ? (
              <button className="btn btn-secondary" onClick={handleLogout}>
                Finalizar
              </button>
            ) : (
              <button className="btn btn-secondary" onClick={onClose}>
                Cerrar sesión
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomModal;
